export default {
  data() {
    return {
      loader: null,
      errorMessage: null,
      backToAllAlbums: false,
    };
  },
  computed: {
    prevUrl() {
      if (this.backToAllAlbums) {
        return null;
      }

      return this.album.is_private ? 'my-photos' : `cat/${this.album.album_category_id}`;
    },
    albumId() {
      return this.album.is_private
        ? `${this.album.hash}-${this.album.hash_password}`
        : this.album.id;
    },
    privateTags() {
      return localStorage.getItem('private-tags') || null;
    },
    downloadUrl() {
      let url = this.$route.params.hash;
      const tag = this.$route.params.tag;

      if (url) {
        url+= '/download';
      } else {
        url = '#';
      }

      if (tag) {
        url+= `?tag=${tag}`;
      }

      return url;
    },
    isOrderFavoritePhotos() {
      return this.$store.getters.ORDER_FAVORITE_PHOTOS;
    },
    favoritesLength() {
      let favorites = [];

      if (this.album && this.favorites && this.favorites.length > 0) {
        this.favorites.forEach((album) => {
          if (album.albumId === this.album.id) {
            album.items.forEach((photo) => {
              favorites.push(photo);
            });
          }
        });
      }

      return favorites.length;
    },
  },
  watch: {
    pricelists(pricelists) {
      if (pricelists && !this.album) {
        this.loadAlbum(this.$route.params.hash);
      }
    },
    async album(album) {
      if (album) {
        this.$store.commit('SET_PRODUCTS', null);

        if (album.status === '1' || album.status === '2' &&
            isNaN(this.$route.params.hash)) {
          if (this.$route.params.photo) {
            this.$store.dispatch('SET_ORDER_STEP', 1);
            this.$store.dispatch('SET_PHOTO',
                this._.find(this.album.album_items,
                    {id: this.$route.params.photo}));
          }

          if (this.uuid && !this.set) {
            await this.$store.dispatch('INIT_PRODUCTS');
            await this.$store.dispatch('INIT_ORDER_BY_UUID', this);

            this.loader.hide();
          } else {
            this.loader.hide();
            await this.$store.dispatch('INIT_PRODUCTS');
          }
        } else {
          this.loader.hide();
          this.$router.push(this.i18nLink('/'));
        }
      }
    },
  },
  methods: {
    async loadAlbum(id) {
      this.loader = this.$loading.show({opacity: this.uuid ? 1 : .5});

      this.$store.dispatch('SET_ALBUM', null);
      const album = await this.$store.dispatch('INIT_ALBUM', id);

      //this.loader.hide();

      if (!album || album && !album.id || album.error) {
        // this.$router.push(this.i18nLink('404'));
        this.errorMessage = album && album.message ? album.message : this.$t('error');
        this.loader.hide();
      } else {
        this.$store.dispatch('SET_TAGS', album.image_tags);
        this.$store.dispatch('SET_CURRENT_TAG', null);
        this.$store.dispatch('SET_CURRENT_SORT_PARAM', this.$store.getters.DEFAULT_SORT_PARAM);

        if (!localStorage.getItem(`notifyInfo-album-${album.id}`) &&
            localStorage.getItem('cookies') && +album.request_contact_data) {
          this.showNotificationsModal(album.total_pictures,
              +album.contact_data_required);
        }

        if (album.is_private || this.$route.name === 'tag') {
          this.handleCustomerAlbum(album);
        }

        if (this.coupon && this.getCouponTime(this.coupon.valid_to) > 0 && !this.uuid) {
          this.showCouponBanner();
        } else {
          this.$bvToast.hide();
        }

        if (this.$store.getters.ORDER_FAVORITE_PHOTOS) {
          this.orderFavoritePhotos();
        }
      }
    },
    orderAllPhotos() {
      this.handleOrder(this.photos);
    },
    orderFavoritePhotos(reload = true) {
      if (this.album && this.album.id) {
        const favorites = this._.find(this.favorites, {
          albumId: this.album.id,
        });

        const photos = [];
        const favoritePhotos = favorites && favorites.items
            ? favorites.items
            : [];

        favoritePhotos.forEach((item) => {
          let photo = this._.find(this.album.album_items, {id: item.photoId});

          if (photo) {
            photos.push(
                this._.find(this.album.album_items, {id: item.photoId}));
          }
        });

        this.handleOrder(photos, reload);
      }
    },
    handleOrder(photos, reload = true) {
      this.$store.dispatch('INIT_ORDER');

      const order = this.myOrder;
      order.quantity = photos.length;

      this.$store.dispatch('SET_MASS', true);
      this.$store.dispatch('SET_PHOTO', this._.first(photos));
      this.$store.dispatch('SET_PHOTOS', photos);
      this.$store.dispatch('SET_ORDER', order);

      if (reload) {
        this.$router.push(
            this.i18nLink(`album/gallery/${this.getAlbumId()}/order`));
      }
    },
  },
  created() {
    if (this.prevRoute && this.prevRoute.name) {
      switch (this.prevRoute.name) {
        case 'home':
        case 'all-albums':
        case 'albums-archive':
          this.backToAllAlbums = true;
      }
    }

    if (this.$route.name === 'download-album') {
      const form = document.createElement('form');

      form.method = 'POST';
      form.action = `${this.apiUrl}v2/albums/${this.$route.params.hash}/download/${this.$route.params.downloadToken}`;

      document.body.appendChild(form);
      form.submit();
      form.remove();
    } else if (this.pricelists) {
      this.loadAlbum(`${this.$route.params.hash}`);
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener('scroll', () => {
        const albumActions = document.getElementsByClassName('album-action-fullscreen-header');

        if (albumActions && albumActions.length > 0) {
          for (let i in albumActions) {
            if (albumActions[i].style) {
              if (window.pageYOffset > 150) {
                albumActions[i].classList.add('album-action-fullscreen-header--is-visible');
              } else {
                albumActions[i].classList.remove('album-action-fullscreen-header--is-visible');
              }
            }
          }
        }
      });
    });
  }
};
